import React, { useState } from 'react';
import { format as fnsFormat, addHours, startOfHour } from 'date-fns';

/**
 * ScheduleModal — date/time picker for scheduling a social post.
 *
 * Props:
 *  - open        : boolean
 *  - currentDate : Date | null (currently scheduled date)
 *  - onSchedule  : (isoString) => void
 *  - onUnschedule: () => void
 *  - onClose     : () => void
 */
export default function ScheduleModal({ open, currentDate, onSchedule, onUnschedule, onClose }) {
  const defaultDate = currentDate
    ? fnsFormat(new Date(currentDate), "yyyy-MM-dd'T'HH:mm")
    : fnsFormat(addHours(startOfHour(new Date()), 1), "yyyy-MM-dd'T'HH:mm");

  const [dateValue, setDateValue] = useState(defaultDate);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!dateValue) return;
    onSchedule(new Date(dateValue).toISOString());
  };

  const minDate = fnsFormat(new Date(), "yyyy-MM-dd'T'HH:mm");

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/60 tw-backdrop-blur-sm">
      <form
        onSubmit={handleSubmit}
        className="tw-bg-zinc-900 tw-border tw-border-zinc-700 tw-rounded-2xl tw-p-6 tw-w-full tw-max-w-sm tw-shadow-2xl"
      >
        <h3 className="tw-text-sm tw-font-bold tw-text-white tw-mb-4">Schedule Post</h3>

        <label className="tw-label">Publish Date & Time</label>
        <input
          type="datetime-local"
          value={dateValue}
          onChange={(e) => setDateValue(e.target.value)}
          min={minDate}
          className="tw-input tw-mb-4"
          required
        />

        {currentDate && (
          <div className="tw-text-xs tw-text-zinc-500 tw-mb-3">
            Currently scheduled: {fnsFormat(new Date(currentDate), 'MMM d, yyyy h:mm a')}
          </div>
        )}

        <div className="tw-flex tw-gap-2">
          <button type="submit" className="tw-btn-primary tw-flex-1 tw-text-xs">
            📅 Schedule
          </button>
          {currentDate && (
            <button
              type="button"
              onClick={onUnschedule}
              className="tw-btn-danger tw-flex-1 tw-text-xs"
            >
              ✕ Unschedule
            </button>
          )}
          <button
            type="button"
            onClick={onClose}
            className="tw-btn-secondary tw-flex-1 tw-text-xs"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
